import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../constants/ActionNameConstants';
import { READ_NOTIFICATION_API_URL } from '../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../features/axiosClient';
import { ReadNotificationFailure, ReadNotificationSuccess } from '../actions';

const ReadNotificationAPI = (action) => postApiRequest(READ_NOTIFICATION_API_URL, action);

function* handleReadNotification(action) {
  try {
    const response = yield call(ReadNotificationAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(ReadNotificationSuccess(response));
  } catch (error) {
    yield put(ReadNotificationFailure(error));
  }
}

export function* watchReadNotification() {
  yield takeLatest(types.READ_NOTIFICATION_REQUEST, handleReadNotification);
}
